/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import { Button, Divider, Grid } from '@mui/material';
import React, { useState } from 'react'
import { Box } from '@mui/system';
import BackButton from '../../../../../components/shared/Buttons/BackButton';
import UserLoginId from '../views/loginid/UserLoginId';
import UserLoginIdCreation from '../views/loginid/UserLoginIdCreation';
import { makeStyles } from 'tss-react/mui';
 import { BrowserView, MobileView } from 'react-device-detect';
 
const ManageLoginidUsersPage = () => {
    const [show, setShow] = useState("registerLoginId");
    const { classes } = useStyles();

    return (
        <>
            <Box m={6}>
                <Grid container spacing={4} >
                    <Grid item xs={12} sm={12} md={12}>
                        <BackButton pageTitle={'Manage LoginID Users'} />
                    </Grid> 
                    <Grid item xs={12} sm={12} md={12} >
                        <BrowserView>
                            <Divider component="div" role="presentation" className={classes.divider}>
                                <Button variant={show === "registerLoginId" ? "contained" : "outlined"} color="success" onClick={() => setShow("registerLoginId")} >Register  using LoginID</Button>
                                <Button variant={show === "loginLoginId" ? "contained" : "outlined"} color="success" style={{ marginLeft: '40px' }} onClick={() => setShow("loginLoginId")}>login using LoginID</Button>
                                <Button variant={show === "registerGetchkd" ? "contained" : "outlined"} color="success" style={{ marginLeft: '40px' }} onClick={() => setShow("registerGetchkd")}>Register Getchkd user</Button>

                            </Divider>
                        </BrowserView>
                        <MobileView>
                                <Button variant={show === "registerLoginId" ? "contained" : "outlined"} color="success"  style={{ marginTop: '10px' }}  onClick={() => setShow("registerLoginId")} >Register  using LoginID</Button>
                                <Button variant={show === "loginLoginId" ? "contained" : "outlined"} color="success" style={{ marginTop: '10px' }} onClick={() => setShow("loginLoginId")}>login using LoginID</Button>
                                <Button variant={show === "registerGetchkd" ? "contained" : "outlined"} color="success" style={{ marginTop: '10px' }} 
                                onClick={() => setShow("registerGetchkd")}>Register GetChkd User</Button>
                        </MobileView>
                    </Grid>
                    <Grid item xs={12} sm={2} md={2} />
                    {show === "registerLoginId" && <Grid item xs={12} sm={8} md={8}>
                        <UserLoginIdCreation />
                    </Grid>}
                    {show === "loginLoginId" && <Grid item xs={12} sm={8} md={8}>
                        <UserLoginId />
                    </Grid>}
                    {/* {show === "registerGetchkd" && <Grid item xs={12} sm={8} md={8}>
                        <GetchkdUserCreation />
                    </Grid>} */}
                </Grid>

            </Box>

        </>
    )
}
const useStyles = makeStyles({ "name": { UserLoginIdCreation } })(theme => ({
    divider: {
        color: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
        "&::before": {
            borderTop: '3px solid ' + theme.palette.success.main

        }, "&::after": {
            borderTop: '3px solid  ' + theme.palette.success.main

        }
    }
}))
export default ManageLoginidUsersPage;